<div class="back_img">
  <div class="row add-p-tb">
    <div class="col-12 d-flex align-items-center bg-white">
      <div class="container my-auto">
        <div class="row menu-column border border-rad">
          <div
            class="col-12 bg-primary text-white menu-head border-rad h4 text-center"
          >
            Workpermission Details
          </div>
          <div class="col col-pn">
            <table class="table m-b-0" *ngIf="response.data">
              <tr>
                <td>Employee</td>
                <td>{{ response.data.EmpId }} - {{ response.data.EmpName }}</td>
              </tr>
              <tr>
                <td>Office</td>
                <td>{{ response.data.office_address }}</td>
              </tr>
              <tr>
                <td>Seat No</td>
                <td>{{ response.seat.seat_id }}</td>
              </tr>
              <tr>
                <td>Booking Date</td>
                <td>
                  {{ response.data.start_date_of_visit | date: "dd/MM/yyyy" }}
                </td>
              </tr>
              <tr>
                <td>Book Time From</td>
                <td>{{ response.seat.book_time_from }}</td>
              </tr>
              <tr>
                <td>Book Time To</td>
                <td>{{ response.seat.book_time_to }}</td>
              </tr>
              <tr>
                <td>Oximeter</td>
                <td>{{ response.seat.check_in_oxygen }}</td>
              </tr>
              <tr>
                <td>Body Temprature (in Celcius)</td>
                <td>{{ response.seat.check_in_temp }}</td>
              </tr>
            </table>
          </div>
        </div>

        <!-- <div class="text-center" *ngIf="response.alert != ''">
          <h3 class="text-danger">
            <b>{{ response.alert }}</b>
          </h3>
        </div> -->

        <div
          class="text-center"
          *ngIf="response.status && !response.seat.check_in_oxygen"
        >
          <h3>
            <b>Check-In Details</b>
          </h3>
        </div>

        <div
          class="row m-t-10"
          *ngIf="response.status && !response.seat.check_in_oxygen"
        >
          <div class="col-md-6">
            <div class="form-group">
              <label>Oximeter </label>
              <input
                type="number"
                class="form-control"
                placeholder="Oximeter"
                [(ngModel)]="checkinDetails.check_in_oxygen"
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Body Temperature (in Celcius)</label>
              <input
                type="number"
                class="form-control"
                placeholder="Body Temperature"
                [(ngModel)]="checkinDetails.check_in_temp"
              />
            </div>
          </div>
        </div>
        <section
          class="row d-flex justify-content-center pt-10"
          *ngIf="response.status && !response.seat.check_in_oxygen"
        >
          <button
            type="submit"
            class="btn btn-primary btn-sm m-r-5"
            (click)="submitCheckinDetail()"
          >
            Submit
          </button>
        </section>

        <div class="row">
          <div class="col-12 error-box">
            <span *ngIf="response.status">
              <img
                src="assets/img/valid.png"
                alt=""
                style="height: 80px; width: 80px"
              />
              <div>
                <b>{{ response.msg }}</b>
              </div>
            </span>
            <span *ngIf="!response.status">
              <img
                src="assets/img/invalid.png"
                alt=""
                style="height: 80px; width: 80px"
              />
              <div>
                <b>{{ response.msg }}</b>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /Main Wrapper -->
